
namespace Matrix.Indexation {

    @Serenity.Decorators.registerClass()
    export class FactIndexationProfileSecurityGrid extends SiteEntityGrid<FactIndexationProfileSecurityRow, any> {
        protected getColumnsKey() { return FactIndexationProfileSecurityColumns.columnsKey; }
        protected getDialogType() { return FactIndexationProfileSecurityDialog; }
        protected getIdProperty() { return FactIndexationProfileSecurityRow.idProperty; }
        protected getInsertPermission() { return FactIndexationProfileSecurityRow.insertPermission; }
        protected getLocalTextPrefix() { return FactIndexationProfileSecurityRow.localTextPrefix; }
        protected getService() { return FactIndexationProfileSecurityService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}